import Marquee from '../components/ui/Marquee';
import Reveal from '../components/ui/Reveal';
import { Section, SectionHeading } from '../components/ui/Section';

import ligue1 from '../assets/league/Ligue_1.png';
import ligue2 from '../assets/league/Ligue_2.png';
import liguePlus from '../assets/league/ligue1+.webp';
import can from '../assets/league/caf.png';
import jupiler from '../assets/league/Jupiler_Pro_League.png';
import ufc from '../assets/league/UFC.png';
import uefaNations from '../assets/league/UEFA_Nations.png';
import rsl from '../assets/league/rsl.png';
import bundesliga from '../assets/league/Bundesliga.png';
import mls from '../assets/league/MLS.png';
import ligaPortugal from '../assets/league/Primeira_Liga.png';
import serieA from '../assets/league/Serie_A.png';
import premierLeague from '../assets/league/Premier_League.png';
import f1 from '../assets/league/F1.png';
import europaLeague from '../assets/league/UEFA_Europa_League.png';
import champions from '../assets/league/Logo_Champions_League.png';
import laliga from '../assets/league/LaLiga.png';

const LEAGUES = [
    { name: 'Ligue 1+', src: liguePlus },
    { name: 'Ligue 1', src: ligue1 },
    { name: 'Ligue 2', src: ligue2 },
    { name: 'UEFA Champions League', src: champions },
    { name: 'UEFA Nations League', src: uefaNations },
    { name: 'LaLiga', src: laliga },
    { name: 'UEFA Europa League', src: europaLeague },
    { name: 'Premier League', src: premierLeague },
    { name: 'Serie A', src: serieA },
    { name: 'Jupiler Pro League', src: jupiler },
    { name: 'Saudi Pro League', src: rsl },
    { name: 'Bundesliga', src: bundesliga },
    { name: 'MLS', src: mls },
    { name: 'Liga Portugal', src: ligaPortugal },
    { name: 'Formule 1', src: f1 },
    { name: 'UFC', src: ufc },
    { name: "Coupe d'Afrique des Nations", src: can },
];

/*
 * Resolved once at module scope. This previously ran inside an IIFE in the JSX,
 * which re-scanned the asset directory on every single render.
 */
const POSTERS = (() => {
    const context = require.context('../assets/sports', false, /\.(webp|png|jpe?g|svg)$/);
    return context
        .keys()
        .sort((a, b) => a.localeCompare(b))
        .map((key) => context(key));
})();

export default function Sports() {
    return (
        <Section id="chaines" className="border-b border-line">
            <SectionHeading
                eyebrow="Sport en direct"
                title="Tous les championnats et compétitions, sans coupure"
                description="Football, Formule 1, UFC et compétitions internationales : les grandes affiches sont diffusées en direct, en Full HD et 4K."
            />

            <Reveal className="-mx-4 mb-12 md:-mx-8">
                <Marquee
                    items={POSTERS}
                    duration={60}
                    gap="gap-4"
                    aria-label="Compétitions sportives diffusées"
                    renderItem={(src) => (
                        <div className="h-56 w-36 overflow-hidden rounded-xl border border-line sm:h-72 sm:w-48">
                            <img
                                src={src}
                                alt=""
                                aria-hidden="true"
                                loading="lazy"
                                decoding="async"
                                className="h-full w-full object-cover"
                            />
                        </div>
                    )}
                />
            </Reveal>

            <ul className="grid grid-cols-3 gap-3 sm:grid-cols-4 lg:grid-cols-6">
                {LEAGUES.map((league, index) => (
                    <Reveal as="li" key={league.name} delay={Math.min(index * 40, 320)}>
                        <div className="grid h-20 place-items-center rounded-xl border border-line bg-white p-4 transition-transform duration-300 ease-smooth hover:-translate-y-1">
                            <img
                                src={league.src}
                                alt={league.name}
                                loading="lazy"
                                decoding="async"
                                className="max-h-11 w-full object-contain"
                            />
                        </div>
                    </Reveal>
                ))}
            </ul>
        </Section>
    );
}
